import { useState } from "react";
import { apiUrl } from "../commons/inFormTypes";
import ClipLoader from "react-spinners/ClipLoader";

/**
 * Entry page: full browser redirect to ai_backend /api/auth/Login (Option B).
 * Username/password are entered on the Military OAuth login page, not here.
 */
const Login = () => {
    const [loading, setLoading] = useState(false);

    const startOrganizationalLogin = () => {
        setLoading(true);
        window.location.assign(`${apiUrl}auth/Login`);
    };

    return (
        <div className="bg-backGray h-screen pt-[106px] flex justify-center">
            <div className="w-[399px] min-h-[220px] h-fit bg-white rounded-[25px] shadow-main-shadow py-[28px] px-[46px]">
                <p className="text-center text-[15px] font-IRANYekanMedium mb-2">
                    سامانه دستیار هوشمند
                </p>
                <p className="text-center text-[13px] font-IRANYekanMedium text-gray-600 mb-6">
                    برای ورود، از طریق سرویس احراز هویت سازمانی (OAuth) وارد شوید.
                    نام کاربری و رمز عبور در صفحه احراز هویت سازمانی وارد می‌شود.
                </p>
                <div className="flex justify-center items-center">
                    <button
                        type="button"
                        onClick={startOrganizationalLogin}
                        disabled={loading}
                        className="w-full h-[40px] bg-mainColor2 hover:bg-nextColor shadow-norm-shadow rounded-[5px] flex justify-center items-center disabled:opacity-70"
                    >
                        {loading ? (
                            <ClipLoader
                                color="#ffffff"
                                loading={loading}
                                size={30}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            />
                        ) : (
                            <p className="font-IRANYekanExtra text-[15px] text-white">ورود</p>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Login;
